import React, { useRef, useEffect } from "react"
import type Sign from "@/signomatic/app/sign"

interface CanvasProps {
  sign: Sign
  height?: number
}

const Canvas: React.FC<CanvasProps> = ({ sign, height }) => {
  const canvasEl = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    let checks = 20

    const checkCanvas = () => {
      checks -= 1

      if (!canvasEl.current) {
        if (checks <= 0) {
          throw new Error("Canvas not found")
        } else {
          setTimeout(checkCanvas, 50)
          return
        }
      }

      sign.init(canvasEl.current)
    }

    checkCanvas()
  }, [sign])

  return (
    <div className="canvas-wrapper" style={{ height }}>
      <canvas ref={canvasEl} />
    </div>
  )
}

export default Canvas
